import { Box } from "@mui/material";
import Text from "@/components/Text";
import {
  MINI_COG_BORDER_COLOR,
  MINI_COG_PANEL_BACKGROUND,
} from "../initial-f2f-mini-cog-constant";

export interface MiniCogStepHeadingProps {
  children: string;
}

const MiniCogStepHeading = ({ children }: MiniCogStepHeadingProps) => (
  <Box
    sx={{
      bgcolor: MINI_COG_PANEL_BACKGROUND,
      border: `1px solid ${MINI_COG_BORDER_COLOR}`,
      borderRadius: 1,
      px: 1.5,
      py: 1,
    }}
  >
    <Text size={13} fontWeight="bold">
      {children}
    </Text>
  </Box>
);

export default MiniCogStepHeading;
